import { phase2CalculatorDefinitions } from './definitions';
import { phase3CalculatorDefinitions } from './phase3Definitions';
import type { CalculatorDefinition } from './types';

export const calculatorDefinitions: readonly CalculatorDefinition[] = [
  ...phase2CalculatorDefinitions,
  ...phase3CalculatorDefinitions,
];

export function getCalculatorBySlug(slug: string): CalculatorDefinition | undefined {
  return calculatorDefinitions.find((calculator) => calculator.slug === slug);
}

export function searchCalculators(query: string): readonly CalculatorDefinition[] {
  const normalized = query.trim().toLocaleLowerCase('ko-KR');

  if (!normalized) {
    return calculatorDefinitions;
  }

  return calculatorDefinitions.filter((calculator) => {
    const haystack = [
      calculator.title,
      calculator.description,
      ...calculator.aliases,
    ]
      .join(' ')
      .toLocaleLowerCase('ko-KR');

    return haystack.includes(normalized);
  });
}
